import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/components/common/SafeIcon';
import { useAuthContext } from '@/components/auth/AuthProvider';

const { FiUser, FiMail, FiCalendar, FiLogOut, FiChevronLeft } = FiIcons;

export default function Profile() {
  const navigate = useNavigate();
  const { user, signOut } = useAuthContext();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center">
        <p className="text-gray-500">載入中...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen min-h-[100dvh] bg-[#0a0a0c] flex flex-col">
      <div className="grain-overlay" />
      <div className="vignette" />

      {/* 返回按鈕 */}
      <header className="fixed top-0 left-0 z-50 p-6 md:p-10">
        <button
          onClick={() => navigate('/bar')}
          className="group flex items-center space-x-2 text-gray-400 hover:text-amber-400 transition-colors"
        >
          <div className="w-10 h-10 rounded-full border border-white/10 group-hover:border-amber-400/50 flex items-center justify-center bg-white/[0.02] backdrop-blur-sm transition-all">
            <SafeIcon icon={FiChevronLeft} className="text-base group-hover:-translate-x-0.5 transition-transform" />
          </div>
          <span className="text-[10px] tracking-[0.3em] uppercase hidden sm:block">Back</span>
        </button>
      </header>

      {/* 主要內容 */}
      <div className="flex-1 flex items-center justify-center p-6 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 w-full max-w-md"
        >
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 shadow-2xl">
            <div className="text-center mb-8">
              <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center">
                <SafeIcon icon={FiUser} className="text-3xl text-white" />
              </div>
              <h2 className="text-2xl text-white font-serif tracking-widest mb-2">
                {user.name || '旅人'}
              </h2>
              <p className="text-gray-500 text-xs tracking-wider uppercase">
                Midnight Traveler
              </p>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-4 p-4 bg-white/5 rounded-xl border border-white/5">
                <SafeIcon icon={FiMail} className="text-amber-400" />
                <div className="flex-1">
                  <p className="text-gray-500 text-xs mb-1">Email</p>
                  <p className="text-white text-sm">{user.email}</p>
                </div>
              </div>

              <div className="flex items-center space-x-4 p-4 bg-white/5 rounded-xl border border-white/5">
                <SafeIcon icon={FiCalendar} className="text-amber-400" />
                <div className="flex-1">
                  <p className="text-gray-500 text-xs mb-1">加入時間</p>
                  <p className="text-white text-sm">
                    {user.createdAt ? new Date(user.createdAt).toLocaleDateString('zh-TW') : '未知'}
                  </p>
                </div>
              </div>

              <div className="p-4 bg-amber-500/10 border border-amber-500/30 rounded-xl">
                <p className="text-amber-400 text-xs font-medium mb-2">會員方案</p>
                <p className="text-amber-200 text-sm">免費方案</p>
                <p className="text-amber-300/60 text-xs mt-1">每日 5 則訊息 · 1 次單張塔羅</p>
              </div>
            </div>

            <button
              onClick={handleSignOut}
              className="w-full bg-red-500/10 border border-red-500/30 text-red-400 py-3 rounded-xl hover:bg-red-500/20 transition-colors flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiLogOut} />
              <span className="tracking-widest">登出</span>
            </button>
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-600 text-[10px]">
              {/* 🔧 修復說明文字: 是 user 表格,不是 users */}
              在 NCB Dashboard 的 Collections → <strong>user</strong> 可查看所有帳戶記錄
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}